import React, { FC } from 'react';
import { Banner, BannerVariant } from 'components/Banner';
import { Icon } from 'components/Icon';
import { Trans, useTranslation } from 'react-i18next';
import styles from './DeliveryMapBanner.module.scss';
import clsx from 'clsx';
import Typography from 'components/Typography/Typography';
import { DELIVERY_MAP_BANNER_TEST_ID } from './DeliveryMapBanner.const';

type Props = {
  className?: string;
  href?: string;
};

export const DeliveryMapBanner: FC<Props> = ({ className, href }) => {
  const { t } = useTranslation();

  return (
    <Banner
      variant={BannerVariant.INFO}
      className={clsx(styles.deliveryBanner, className)}
      rounded={true}
      data-testid={DELIVERY_MAP_BANNER_TEST_ID.root}
    >
      <div className={styles.icon}>
        <Icon aria-hidden={true} name="mapSearch" size={24} />
      </div>
      <Typography.Body variant="tertiary">
        <Typography.Body variant="tertiary" bold>
          {t('deliveryMapBanner.title')}
          <br />
        </Typography.Body>
        <Trans i18nKey="deliveryMapBanner.cta">
        See it on DoorDash’s real-time <a href={href} data-testid={DELIVERY_MAP_BANNER_TEST_ID.link}>delivery map</a>.
        </Trans>
      </Typography.Body>
    </Banner>
  );
};
